function parsePathOrPattern(pathOrPattern: string) {
    return pathOrPattern.split("/").filter((part) => part !== "");
}
export function doesPathMatchPattern(path: string, pattern: string) {
    const patternParts = parsePathOrPattern(pattern);
    const output: Record<string, string> = {};
    const pathParts = parsePathOrPattern(path);
    if (pathParts.length !== patternParts.length) return false;
    for (let i = 0; i < pathParts.length; i++) {
        const patternPart = patternParts[i];
        const pathPart = pathParts[i];
        if (patternPart === undefined) return false;
        if (pathPart === undefined) return false;
        if (patternPart.startsWith(":")) {
            output[patternPart.slice(1)] = pathPart;
        } else {
            if (patternPart !== pathPart) return false;
        }
    }
    return output;
}

export function doesPathStartsWithPattern(path: string, pattern: string) {
    const patternParts = parsePathOrPattern(pattern);
    const output: Record<string, string> = {};
    const pathParts = parsePathOrPattern(path);
    for (let i = 0; i < patternParts.length; i++) {
        const patternPart = patternParts[i];
        const pathPart = pathParts[i];
        if (patternPart === undefined) return false;
        if (pathPart === undefined) return false;
        if (patternPart.startsWith(":")) {
            output[patternPart.slice(1)] = pathPart;
        } else {
            if (patternPart !== pathPart) return false;
        }
    }
    return output;
}
